import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { Shell } from './components/shell.js';
import { ApiKeys } from './routes/api-keys.js';
import { Billing } from './routes/billing.js';
import { Login } from './routes/login.js';
import { Overview } from './routes/overview.js';
import { Settings } from './routes/settings.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Les données de consommation ne bougent qu'à la minute (ADR-005) :
      // inutile de refetch à chaque retour d'onglet.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  // `/login` est hors de `Shell` : la coquille exige une session, l'y placer
  // créerait une redirection en boucle.
  { path: '/login', element: <Login /> },
  {
    element: <Shell />,
    children: [
      { path: '/', element: <Overview /> },
      { path: '/keys', element: <ApiKeys /> },
      { path: '/billing', element: <Billing /> },
      { path: '/settings', element: <Settings /> },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) {
  throw new Error("L'élément racine #root est absent du document.");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
